import { useEffect, useState, useSyncExternalStore } from 'react'
import {
  applyThemePreference,
  getResolvedTheme,
  readThemePreference,
  setThemePreference,
  subscribeTheme,
  type ThemePreference,
  type ResolvedTheme,
} from '../lib/theme'

function subscribeSystem(listener: () => void): () => void {
  const mq = window.matchMedia('(prefers-color-scheme: dark)')
  mq.addEventListener('change', listener)
  return () => mq.removeEventListener('change', listener)
}

/** Keeps preference + resolved theme in sync with storage and OS. */
export function useTheme(): {
  preference: ThemePreference
  resolved: ResolvedTheme
  setPreference: (next: ThemePreference) => void
} {
  const [preference, setPreferenceState] = useState<ThemePreference>(() => readThemePreference())
  const resolved = useSyncExternalStore(subscribeTheme, getResolvedTheme, () => 'dark')

  useEffect(() => {
    applyThemePreference(preference)
  }, [preference])

  useEffect(() => {
    if (preference !== 'system') return
    return subscribeSystem(() => {
      applyThemePreference('system')
    })
  }, [preference])

  return {
    preference,
    resolved,
    setPreference: (next) => {
      setPreferenceState(next)
      setThemePreference(next)
    },
  }
}
